import gql from 'graphql-tag';

export const GET_VISIT = gql`
    query Query ($ID:ID!) {
        visita(id:$ID) {
            id
            entidad {
                nombre
                productor {
                    persona {
                        nombre
                        apellido
                        cedula
                    }
                }
            }
            profesional {
                usuario {
                    persona {
                        nombre
                        apellido
                    }
                }
            }
            norma {
                descripcion
            }
            fecha
            capitulos
            anexosTemp
        }
    }
`;

export const GENERATE_ZIPPED_ANNEXES = gql`
    mutation($files:GenericScalar!, $visitId:ID!){
        generateZippedAnnexes(input: {filesUrls: $files, visitId:$visitId}){
            response
        }
    }
`;
